import { useT } from '../i18n';
import { BOT_USERNAME } from '../lib/bot-username';

export function NotInTelegramScreen() {
  const t = useT();
  return (
    <main className="min-h-dvh bg-bg text-text flex flex-col items-center justify-center gap-4 px-6 text-center">
      <div className="text-5xl">💬</div>
      <h1 className="text-xl font-semibold">{t.notInTelegram.title}</h1>
      <p className="text-hint">{t.notInTelegram.body}</p>
      <a className="text-link font-medium" href={`https://t.me/${BOT_USERNAME}`}>
        {t.notInTelegram.openBot}
      </a>
    </main>
  );
}
